import React from "react";

export const Clock = () => {
  return (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
      <g
        opacity={0.3}
        stroke="#214160"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 11A5 5 0 106 1a5 5 0 000 10z" />
        <path d="M6 3.001v3l2 1" />
      </g>
    </svg>
  );
};
